function actionAbortKey(moduleId: string, actionName: string): string {
  return `${moduleId}\0${actionName}`;
}

const controllers = new Map<string, AbortController>();

/**
 * Cancel any in-flight request for the same module action and return a fresh
 * {@link AbortSignal} for the new request (design: latest interaction wins).
 */
export function supersedeActionRequest(moduleId: string, actionName: string): AbortSignal {
  const key = actionAbortKey(moduleId, actionName);
  controllers.get(key)?.abort();
  const next = new AbortController();
  controllers.set(key, next);
  return next.signal;
}

/**
 * Remove the registry entry when the request that created {@link signal} is done,
 * so a completed request does not block future aborts.
 */
export function releaseActionAbortSlot(
  moduleId: string,
  actionName: string,
  signal: AbortSignal,
): void {
  const key = actionAbortKey(moduleId, actionName);
  const current = controllers.get(key);
  if (current?.signal === signal) {
    controllers.delete(key);
  }
}
